/**************************************************
 * Nombre:       Home_Bienvenido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_bienvenido.svg'
import {NEGRITA} from "../../../Constantes";
import ic_habitaciones from '../../../Recursos/ic_habitaciones.svg'
import ic_atencion from '../../../Recursos/ic_atencion.svg'
import ic_aire from '../../../Recursos/ic_aire.svg'
import ic_servicio from '../../../Recursos/ic_servicio.svg'
import Tarjeta_Caracteristicas from "../../Tarjetas/Tarjeta_Caracteristicas";
import Barra_Servicios from "./SubComponentes/Barra_Servicios";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Bienvenido = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: 22, pb: 10}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: !masSM ? 'center' : 'flex-start', mt: !masSM ? 24 : 0}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontWeight: 800,
                                    fontSize: !masSM ? 48 : 64,
                                    lineHeight: 1.1,
                                    textAlign: !masSM ? 'center' : 'left'
                                }}>
                                Bienvenido a Tumaco
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography sx={{fontWeight: 400, fontSize: 16, textAlign: sCell ? 'center' : 'left'}}>
                                Con más <span style={{fontWeight: 600,}}>de 17 años de experiencia</span>, el Hotel Mar
                                Azul ofrece una cálida hospitalidad en
                                el centro de Tumaco, cerca de los muelles para avistamiento de ballenas y a solo 15
                                minutos de la playa El Morro. Con precios accesibles, somos el destino ideal para
                                viajeros de negocios y turismo.
                            </Typography>
                        </Grid>

                    </Grid>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        {items.map((item, i) => (
                            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Caracteristicas item={item}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mb: sCell ? -28 : -18, mt: 6}}>
                    <Barra_Servicios/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Bienvenido

const items = [
    {
        img: ic_habitaciones,
        nombre: 'Habitaciones Cómodas',
        descripcion: 'Disfruta de nuestras habitaciones con amplias camas y todo el confort necesario para una estadía placentera en el Hotel Mar Azul.'
    },
    {
        img: ic_atencion,
        nombre: 'Atención para tus eventos',
        descripcion: 'El Hotel Mar Azul ofrece un salón de eventos ideal para reuniones y celebraciones, equipado para asegurar que tu evento sea un éxito.'
    },
    {
        img: ic_aire,
        nombre: 'Aire Acondicionado',
        descripcion: 'En el Hotel Mar Azul, cada habitación cuenta con aire acondicionado, asegurando un ambiente fresco y cómodo para nuestros huéspedes en todo momento.'
    },
    {
        img: ic_servicio,
        nombre: 'Servicio de Restaurante',
        descripcion: 'Disfruta de nuestro servicio de restaurante con previa reservación, ideal para una experiencia gastronómica privada y personalizada en el Hotel Mar Azul.'
    }
]